import { render, staticRenderFns } from "./Floor3.vue?vue&type=template&id=2bd4cbf5&scoped=true"
import script from "./Floor3.vue?vue&type=script&lang=js"
export * from "./Floor3.vue?vue&type=script&lang=js"
import style0 from "./Floor3.vue?vue&type=style&index=0&id=2bd4cbf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4cbf5",
  null
  
)

export default component.exports